import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Formik, Form, Field } from "formik";
import { useTranslation } from "react-i18next";
import { Input, Button } from "components/bootstrap";
import { Icon } from "components/common";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import UserNotification from "util/UserNotification";
const SurveyWrapper = styled.div(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.cards.border};
    border-radius: ${theme.spacings.sm};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.sm};
    padding: ${theme.spacings.sm} ${theme.spacings.md};
  `
);
const RatingWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
const RatingText = styled.p(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
    margin-bottom: 0;
  `
);
const Ratings = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${theme.spacings.sm};

    & .form-group {
      margin-bottom: 0 !important;
    }
  `
);
const StyledRadioInput = styled(Input)`
  margin-top: 0;
  margin-bottom: 0;

  & label {
    padding-left: 0;
  }

  & input {
    visibility: hidden;
  }
`;
const StyledIcon = styled(Icon)(
  ({ theme, $checked, $disabled }) => css`
    color: ${$checked ? theme.colors.text.secondary : void 0};
    cursor: ${$disabled ? "default" : "pointer"};
    margin-bottom: 0;
  `
);
const ratings = [
  { titleKey: "satisfaction_survey.excellent", icon: "sentiment_very_satisfied", value: 3 },
  { titleKey: "satisfaction_survey.ok", icon: "sentiment_satisfied", value: 2 },
  { titleKey: "satisfaction_survey.not_good", icon: "sentiment_dissatisfied", value: 1 }
];
const SatisfactionSurvey = () => {
  const { t } = useTranslation("enterprise_security_investigations");
  const sendTelemetry = useSendTelemetry();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const onSubmit = (values) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_REPORT_BY_AI.USER_SURVEY, {
      app_value: values
    });
    setIsSubmitted(true);
    UserNotification.success(t("satisfaction_survey.thank_you"));
  };
  return isSubmitted ? null : /* @__PURE__ */ React.createElement(Formik, { onSubmit, initialValues: { rating: void 0, review: void 0 } }, ({ values }) => /* @__PURE__ */ React.createElement(Form, { className: "form" }, /* @__PURE__ */ React.createElement(SurveyWrapper, null, /* @__PURE__ */ React.createElement(RatingWrapper, null, /* @__PURE__ */ React.createElement(RatingText, null, t("satisfaction_survey.question")), /* @__PURE__ */ React.createElement(Ratings, null, /* @__PURE__ */ React.createElement(Field, { name: "rating" }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(React.Fragment, null, ratings.map(({ value: itemValue, icon, titleKey }) => {
    const checked = value === itemValue;
    const title = t(titleKey);
    return /* @__PURE__ */ React.createElement(
      StyledRadioInput,
      {
        key: itemValue,
        id: `${name}-${itemValue}`,
        onChange: () => onChange({ target: { value: itemValue, name } }),
        checked,
        value: itemValue,
        name,
        disabled: isSubmitted,
        type: "radio",
        label: /* @__PURE__ */ React.createElement(
          StyledIcon,
          {
            $checked: checked,
            $disabled: isSubmitted,
            size: "sm",
            name: icon,
            title,
            "data-testid": `radio-option-${title}`,
            type: checked ? "solid" : "regular"
          }
        )
      }
    );
  }))), !isSubmitted && values.rating && /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", type: "submit" }, t("common:actions.submit")))), values.rating === 1 && !isSubmitted ? /* @__PURE__ */ React.createElement(Field, { name: "review" }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      id: name,
      name,
      type: "textarea",
      value,
      onChange,
      label: /* @__PURE__ */ React.createElement("span", null, t("satisfaction_survey.review_label"), " ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, t("satisfaction_survey.optional"))),
      rows: 4
    }
  )) : null)));
};
export default SatisfactionSurvey;
